import { database } from "@/api/firebase/firebase.config";
import { useEffect, useState } from "react";

export function useDownloadUrl(tenantId: string) {
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const databaseRef = database.ref(`tracker/${tenantId}`);

    const handleValueChange = (snapshot: any) => {
      const data = snapshot.val();

      if (data && data.downloadUrl) {
        setDownloadUrl(data.downloadUrl);
      } else {
        setError(
          new Error(
            "Download is not available at the moment. Please try again later."
          )
        );
      }
      setLoading(false);
    };

    databaseRef.on("value", handleValueChange, (error: any) => {
      setError(
        new Error(
          "Download is not available at the moment. Please try again later."
        )
      );
      setLoading(false);
    });

    return () => {
      databaseRef.off("value", handleValueChange);
    };
  }, [tenantId]);

  return { downloadUrl, loading, error };
}
